import { defineComponent as _defineComponent } from 'vue'
import { fetchEzSortDownloadUrl } from '@/apis/colorLabel'
import ezSortLogo from '@/assets/image/ezSortLogo.png'
import { translateLang } from '@/data/i18n/translateLang'
import { useRoute } from '@/hooks/useRoute'
import { message } from 'ant-design-vue'
import FileSaver from 'file-saver'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'jumpEzSort',
  setup(__props) {

const route = useRoute()
const openSrc = (route.query.openSrc as string) || ''

const isLoading = ref(false)
const showDoloadButton = ref(false)

async function handleDownload() {
  isLoading.value = true
  const res = await fetchEzSortDownloadUrl()
  if (res.status !== 1) {
    return message.error(res.msg)
  }
  const downloadUrl = res.data?.download_url
  if (!downloadUrl) {
    isLoading.value = false
    message.error('error')
    return
  }
  fetch(downloadUrl)
    .then((v) => v.blob())
    .then((v) => {
      const name = downloadUrl.split('/').slice(-1)[0] || 'EZsort.exe'
      FileSaver.saveAs(v, name)
      isLoading.value = false
    })
    .finally(() => {
      isLoading.value = false
    })
}
onMounted(() => {
  if (openSrc) {
    window.open(decodeURIComponent(openSrc), '_self')
    setTimeout(async () => {
      showDoloadButton.value = true
      message.warning(
        translateLang(
          '如果智绘彩标未能正常打开，可能是因为您没有下载，请点击下方按钮下载智绘彩标'
        )
      )
    }, 10000)
  } else {
    showDoloadButton.value = true
  }
})

return { __sfc: true,route, openSrc, isLoading, showDoloadButton, handleDownload, ezSortLogo }
}

})